import { ReactNode } from "react";

import Form from "@atlaskit/form";

import { useAccountCreationContext } from "../../hooks";
import { Error as DefaultError } from "../error";
import { Input as DefaultInput } from "../input";
import { Login as DefaultLogin } from "../login";
import { Separator as DefaultSeparator } from "../separator";
import { Social as DefaultSocial } from "../social";
import { Submit as DefaultSubmit } from "../submit";

export const Content = ({
    Submit = <DefaultSubmit />,
    Input = <DefaultInput />,
    Social = <DefaultSocial />,
    Separator = <DefaultSeparator />,
    Error = <DefaultError />,
    Login = <DefaultLogin />
}: {
    Submit?: ReactNode;
    Input?: ReactNode;
    Separator?: ReactNode;
    Social?: ReactNode;
    Error?: ReactNode;
    Login?: ReactNode;
}) => {
    const { onSubmitWithReCAPTCHA } = useAccountCreationContext();
    return (
        <>
            <Form onSubmit={onSubmitWithReCAPTCHA} isDisabled={false}>
                {({ formProps }) => (
                    <form
                        {...formProps}
                        autoComplete="off"
                        data-testid="account-creation"
                    >
                        {Input}
                        {Submit}
                    </form>
                )}
            </Form>
            {Error}
            {Separator}
            {Social}
            {Login}
        </>
    );
};
